import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/desktop/DesktopDetails/DesktopDetails.jsx");
